export function formatVerificationCode(value, { allowOnlyNumbers = false, length = 6 } = {}) {
  const rawValue = String(value || "");
  const normalizedValue = allowOnlyNumbers
    ? rawValue.replace(/\D/g, "")
    : rawValue.replace(/[^a-zA-Z0-9]/g, "").toUpperCase();

  return normalizedValue.slice(0, length);
}
